export default "__VITE_ASSET__Iojag3SY__"